<template lang="pug">
  .withdrawal-page
    .withdrawal-top
      a(href='#').withdrawal-add-new
        svgicon(name='plus')
        span Новая заявка
      .withdrawal-stat
        .withdrawal-stat__item.item-wd
          .item-wd__title Прибыль
          .item-wd__number 16 856, 25 Р
        .withdrawal-stat__item.item-wd
          .item-wd__title Выплачено
          .item-wd__number 2 906, 25 Р
        .withdrawal-stat__item.item-wd
          .item-wd__title Баланс
          .item-wd__number 9 950 Р
        .withdrawal-stat__item.item-wd
          .item-wd__title Доступно к выводу
          .item-wd__number 0 Р
    .withdrawal
      .withdrawal__warning У вас есть не подписанный отчет. Перейдите по
        a(href='#') этой ссылке
        | и загрузите сканы подписанных документов.
      h2.h2 Вывод денежных средств
      .withdrawal__content
        .tabs
          .tabs__title
            a(href='#'
              v-for="tab in tabs"
              :key="tab.name"
              :class="[{active: currentTab === tab.name}]"
              @click.prevent="currentTab = tab.name"
            ).tabs__link {{ tab.title }}
          .tabs__content
            component(:is="currentTab").tab
</template>

<script>
import {mapGetters} from 'vuex';
import History from '@/components/tabs/History.vue'
export default {
  name: 'Withdrawal-Inner',
  data: function() {
    return {
      windowWidth: null,
      currentTab: 'history',
      tabs: [
        {
          name: 'history',
          title: 'История выплат',
        },
        {
          name: 'events',
          title: 'Начисления по мероприятиям'
        },
        {
          name: 'orders',
          title: 'Начисления по заказам'
        },
        {
          name: 'refunds',
          title: 'Возмещение за возвраты'
        },
      ]
    }
  },
  components: {
    History
  },
  mounted() {
    this.$nextTick(function() {
      window.addEventListener('resize', this.resize);
      this.resize()
    })
  },
  computed: {
    ...mapGetters([
      'withdrawal',
    ]),
    visibleItems(){
      let visibleItems = 0;
      this.withdrawal.forEach(item => {
        if(item.visible == false) {
          visibleItems += 1;
        }
      });
      return this.withdrawal.length == visibleItems;
    },
  },
  methods: {
    onFormat(number) {
      return number.toLocaleString('ru-RU')
    },
    resize() {
      this.windowWidth = document.documentElement.clientWidth;
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
  }
}
</script>

<style lang='scss' scoped>
  .withdrawal-table__th,
  .item-draw__item{
    padding-right: 10px;
  }
  .at-col-1{
    width: 100px;
    flex-grow: 0;
  }
  .at-col-2{
    width: 450px;
    margin-right: auto;
  }
  .at-col-3{
    width: 250px;
  }
  .at-col-4{
    width: 170px;
    flex-shrink: 0;
  }
  .tabs{
    padding: 0;
    &__title{
      margin-bottom: 20px;
    }
  }
  @media (max-width: 767px)  {
    .tabs__title{
      flex-direction: column;
      width: 100%;
    }
  }
</style>
<style lang='scss'>
.withdrawal{
  margin: 40px;
  &__warning{
    color: #e67c27;
    font-size: 16px;
    font-weight: 600;
    font-style: normal;
    letter-spacing: normal;
    line-height: 25px;
    margin-bottom: 35px;
    a{
      display: inline-block;
      margin: 0 5px;
      color: #008cff;
      text-decoration: none;
      &:hover{
        text-decoration: underline;
      }
    }
  }
}
.withdrawal-top{
  margin: 20px 40px 35px;
  display: flex;
}
.withdrawal-add-new{
  flex-shrink: 0;
  margin-right: 20px;
  box-shadow: 0 0 10px rgba(196, 202, 214, 0.8);
  background-color: #008cff;
  text-decoration: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 45px;
  color: #fff;
  min-width: 170px;
  .svg-icon{
    display: block;
    margin-bottom: 15px;
    width: 21px;
    height: 21px;
  }
  &:hover{
    background-color: #026ac0;
  }
}
.withdrawal-stat{
  display: flex;
  flex-grow: 1;
}
.item-wd{
  border: 1px solid #e4e4e4;
  background-color: #ffffff;
  width: 25%;
  padding: 35px 30px;
  margin-left: -1px;
  color: #161616;
  &__title{
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 15px;
  }
  &__text{
    font-size: 16px;
    margin-bottom: 10px;
  }
  &__number{
    font-size: 25px;
    font-weight: 700;
  }
}
@media (max-width: 1199px) {
  .withdrawal-add-new{
    padding: 20px;
  }
  .item-wd {
    padding: 20px 15px;
    &__title {
      font-size: 15px;
    }
    &__number {
      font-size: 20px;
    }
  }
}
@media (max-width: 991px) {
  .withdrawal {
    margin: 20px;
  }
  .item-draw{
    flex-wrap: wrap;
    &__item{
      flex-grow: 0;
      margin-top: 10px;
      margin-bottom: 10px;
      &.at-col-2{
        width: calc(100% - 300px);
      }
      &.at-col-3{
        width: 150px;
      }
      &.at-col-4{
        width: 100%;
        text-align: center;
      }
    }
  }
  .withdrawal-table__title{
    display: none;
  }
  .withdrawal-top{
    margin: 20px;
  }
  .withdrawal-add-new{
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    box-sizing: border-box;
    flex-direction: row;
    font-weight: 700;
    .svg-icon{
      margin-right: 15px;
      margin-bottom: 0;
    }
  }
}
@media (max-width: 767px)  {
  .increase-sales{
    margin: 20px 20px;
  }
  .increase-sales__content{
    flex-direction: column;
  }
  .increase-sales__item{
    margin-right: 0;
    margin-bottom: 20px;
    justify-content: center;
  }
  .item-draw {
    flex-wrap: wrap;
    justify-content: space-between;
    &__item {
      width: calc(50% - 10px);
      &.at-col-2{
        order: -1;
        width: 100%;
      }
    }
  }
  .withdrawal-stat{
    overflow: auto;
  }
  .item-wd{
    width: 200px;
    flex-shrink: 0;
    &:first-child{
      margin-left: 0;
    }
  }
}
@media (max-width: 479px)  {
  .increase-sales__item{
    font-size: 14px;
    padding: 15px;
    justify-content: space-between;
  }
}
</style>